import axios from "axios";
import { Platform } from "expo-modules-core";
import * as SecureStore from "../../components_v2/DeviceAsyncStorage";
import { getServerInfo } from "../../util";
import BuildingInfo from "../../viewModels/BuildingInfo";
import ServerInfo from "../../viewModels/ServerInfo";
import * as Network from "expo-network";
import checkIPAddress from "../checkIPAddress";
const IS_MOBILE = Platform.OS === "android" || Platform.OS === "ios";
interface ServerConnected {
  address: string;
  serverInfo: ServerInfo;
}
export const connectToBuilding = async (
  buildingId: string
): Promise<ServerConnected | null> => {
  let networkType = await Network.getNetworkStateAsync();
  const findBuildingByBuildingId: BuildingInfo | null =
    await SecureStore.Buildings.findBuilding(buildingId);
  if (findBuildingByBuildingId) {
    const { serverId, cloudServerId } = findBuildingByBuildingId;
    // === Server Master ===
    if (serverId) {
      const findServerMaster = await SecureStore.Servers.findServer(serverId);
      if (findServerMaster) {
        const { publicAddress, localAddress } = findServerMaster;
        // === Local Master ===
        if (
          localAddress &&
          checkIPAddress(localAddress) &&
          networkType.type !== "CELLULAR" &&
          IS_MOBILE
        ) {
          const serverInfoMasterLocal = await tryConnect(localAddress, 2000);
          if (serverInfoMasterLocal) {
            return {
              address: localAddress,
              serverInfo: serverInfoMasterLocal,
            };
          }
        }
        // === Local Public ===
        if (publicAddress && publicAddress?.length !== 0) {
          const serverInfoMasterPublic = await tryConnect(publicAddress, 3000);
          if (serverInfoMasterPublic) {
            return {
              address: publicAddress,
              serverInfo: serverInfoMasterPublic,
            };
          }
        }
      }
    }
    // === server Public ===
    if (cloudServerId) {
      const findServerMaster = await SecureStore.Servers.findServer(
        cloudServerId
      );
      if (findServerMaster) {
        const { publicAddress } = findServerMaster;
        if (publicAddress) {
          const serverInfoMasterLocal = await tryConnect(publicAddress, 5000);
          if (serverInfoMasterLocal) {
            return {
              address: publicAddress,
              serverInfo: serverInfoMasterLocal,
            };
          }
        }
      }
    }
  }
  return null;

  // if (findBuildingByBuildingId) {
  //   const { serverId, cloudServerId, localAddress } = findBuildingByBuildingId;
  //   // === find servers by serverId and cloudServerId ===
  //   const masterServerInfo: ServerInfo = await SecureStore.Servers.findServer(
  //     serverId
  //   );
  //   var cloudServerInfo = null;
  //   console.log("masterServerInfo", masterServerInfo);
  //   if (cloudServerId) {
  //     cloudServerInfo = await SecureStore.Servers.findServer(cloudServerId);
  //   }
  //   console.log("cloudServerInfo", masterServerInfo);
  //   if (masterServerInfo) {
  //     // === check localAddress and mobile device ===
  //     if (IS_MOBILE) {
  //       const serverInfoLocal = await tryConnect(localAddress, 2000);
  //       if (
  //         serverInfoLocal &&
  //         (serverInfoLocal.serverId === findBuildingByBuildingId.serverId ||
  //           serverInfoLocal.serverId === findBuildingByBuildingId.cloudServerId)
  //       ) {
  //         console.log("serverInfoLocal", serverInfoLocal);
  //         return serverInfoLocal;
  //       }
  //     }
  //     // === check master connection ===
  //     if (!checkIPAddress(masterServerInfo.publicAddress)) {
  //       const serverInfo = await tryConnect(
  //         masterServerInfo.publicAddress,
  //         2000
  //       );
  //       if (
  //         serverInfo &&
  //         (serverInfo.serverId === findBuildingByBuildingId.serverId ||
  //           serverInfo.serverId === findBuildingByBuildingId.cloudServerId)
  //       ) {
  //         return masterServerInfo;
  //       }
  //     }
  //   }
  //   // === cloud connection ===
  //   if (cloudServerInfo) {
  //     const serverInfo = await tryConnect(cloudServerInfo.publicAddress, 2000);
  //     if (serverInfo) {
  //       return cloudServerInfo;
  //     }
  //   }
  // } else {
  // }
};

export const tryConnect = async (address: string, timeout: number = 3000) => {
  var httpClient = axios.create();
  httpClient.defaults.timeout = timeout;
  const serverInfo = await getServerInfo(httpClient, address);
  return serverInfo;
};

export const tryConnectLocally = (serverId: string) => {};
export const tryConnectPublicly = (serverId: string) => {};
